import styled from 'styled-components'

const UpcomingEventsStyle = styled.div`
	--upcomingEventsTitleMarginBottom: var(--sp8x);
	/* --upcomingEventTitleMaxWidth: var(--sp79x); */
	--upcomingEventsButtonMarginTop: var(--sp8x);

	overflow: hidden;

	.upcoming-events-title {
		margin-bottom: var(--upcomingEventsTitleMarginBottom);
		/* max-width: var(--upcomingEventTitleMaxWidth); */
	}

	.discover-all-events-button {
		display: flex;
		justify-content: center;
		margin-top: var(--upcomingEventsButtonMarginTop);
	}

	.upcoming-events-item {
		margin-bottom: calc(2 * var(--colPadding));
	}

	.upcoming-events-cont > .row {
		margin-bottom: calc(-2 * var(--colPadding));
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp7x);
		--upcomingEventsButtonMarginTop: var(--sp7x);
		/* --upcomingEventTitleMaxWidth: var(--sp68x); */
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp6x);
		--upcomingEventsButtonMarginTop: var(--sp6x);
		/* --upcomingEventTitleMaxWidth: var(--sp57x); */
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp6x);
		--upcomingEventsButtonMarginTop: var(--sp6x);
		/* --upcomingEventTitleMaxWidth: var(--sp46x); */
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp5x);
		--upcomingEventsButtonMarginTop: var(--sp5x);
		/* --upcomingEventTitleMaxWidth: var(--sp46x); */
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp4x);
		--upcomingEventsButtonMarginTop: var(--sp5x);
		/* --upcomingEventTitleMaxWidth: var(--sp36x); */
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp4x);
		--upcomingEventsButtonMarginTop: var(--sp5x);
		/* --upcomingEventTitleMaxWidth: var(--sp36x); */
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--upcomingEventsTitleMarginBottom: var(--sp4x);
		--upcomingEventsButtonMarginTop: var(--sp5x);
		/* --upcomingEventTitleMaxWidth: var(--sp30x); */
	}
`

export default UpcomingEventsStyle
